module.exports = __webpack_public_path__ + "static/app_bar_5-210deb51cf2de176ed7fdf8e71ff0f06.png";